export const SKU_PRIORITY_ORDER = ['max', 'pro_plus', 'trial'] as const

export type SkuType = (typeof SKU_PRIORITY_ORDER)[number]
